<template lang="pug">
  div
    v-dialog(
      v-model="showNewTicketDispatcher"
      max-width="450",
      max-height="calc(100vh - 150px)"
      origin="top right"
      offset-y
      transition="slide-y-transition"
    )
      card-generate-ticket(@close="closeGenerarNuevoTicket")

    v-navigation-drawer(v-model='drawer_settings' :width="isMovil ? '100%' : '380'" app temporary dense right @input="!drawer_settings && $refs.configuraciones.close()")
      configuraciones-app(@close="drawer_settings = false" ref="configuraciones")
    v-navigation-drawer( dense,v-model="mini" , app )
      v-list.py-1(dense,  )
        v-list-item(to="/"  :color="!$vuetify.theme.dark ? 'white' : ''")
          v-list-item-title
            .d-flex.jc-center.ai-center
              v-img(src="/static/logo.png", width="55%")
              v-spacer
              v-chip(color="primary")
                small.font-size-12 Help Desk
      v-divider
      v-list(dense,)
        template(v-for="(m, index) in menu")
          v-list-group(:value='false'  :prepend-icon='m.icon', v-if="m.children && m.children.length", no-action)
            template(v-slot:activator='')
              v-list-item-title {{m.name}}
            v-list-item(v-for='(child, index2) in m.children' :key='index2'  :to="child.path" link)
              v-list-item-icon
                v-icon(v-text='child.icon')
              v-list-item-title(v-text='child.name')
              v-chip(color="primary" x-small label v-if="abiertos[child.key]")
                span {{abiertos[child.key]}}
          v-list-item(v-else, active-class="secondary primary--text"   :to="m.path", link)
            v-list-item-icon
              v-icon {{m.icon}}
            v-list-item-title {{m.name}}
            v-chip(color="primary" x-small label v-if="abiertos[m.key]")
              span {{abiertos[m.key]}}
      template(v-slot:append='')
        .pa-2
          v-btn(block='', :small="!isMovil", color="primary", @click="logout()")
            | Cerrar sesión
    v-app-bar.elevation-1(app, dense, :color=" !$vuetify.theme.dark  ? 'white' : ''")
      v-app-bar-nav-icon(@click.stop='mini = !mini')
      v-spacer
      //- v-btn.ma-5(color="success" :small="!isMovil" :block="isMovil" @click="generarNuevoTicket()" v-if="perfil === 'dispatcher'")
      //-   | Nuevo ticket
      v-btn.ma-5(color="success" :small="!isMovil" :block="isMovil" @click="goToGenerarTicket()" v-if="perfil === 'dispatcher'")
        | Nuevo ticket
      v-tooltip(bottom='')
        template(v-slot:activator='{ on, attrs }')
          v-chip.pa-4( label, v-bind='attrs' v-on='on' to="/profile" color='background')
            v-avatar( left)
              avatar-perfil(:usuario="username" :is-fetch="true")
            span.font-weight-700 {{nombre}}
        small Perfil de tu cuenta
      notificaciones-app
      v-tooltip(bottom='')
        template(v-slot:activator='{ on, attrs }')
          v-btn(icon, v-bind='attrs' v-on='on' @click="drawer_settings = !drawer_settings")
            v-icon tune
        small Configuraciones de la aplicacion

  </template>
  <script>
  import Router                from '../router/dispatcher.js'
  import { apiGet, notify } from '../util/general'
  import avatarPerfil from '@/components/c_avatar_perfil'
  import configuracionesApp from '@/components/c_configuraciones_app'
  import notificationApp from '@/components/c_descargas_procesos_app'
  import cardGenerateTicket from '@/components/c_card_generate_ticket'
  export default {
    props     : ['usuario'],
    components: {
      'avatar-perfil'      : avatarPerfil,
      'configuraciones-app': configuracionesApp,
      'notificaciones-app' : notificationApp,
      'card-generate-ticket' : cardGenerateTicket
    },
    data () {
      return {
        search         : null,
        caseSensitive  : false,
        showNewTicketDispatcher  : false,
        selectedItem   : null,
        menu3          : false,
        drawer_settings: false,
        isGettingEquipos: false,
        equiposDelModeloFiltrados: [],
        modelosAgrupados: [],
        menuUsuario    : [
          {
            name  : 'Mis Tickets',
            path  : '/tickets',
            icon  : 'style',
            key   : 'all_usuario_o_cliente',
            notify: ''
          }
        ],
        menuCustomer   : [
          {
            name  : 'Mis Tickets',
            path  : '/tickets',
            icon  : 'style',
            key   : 'all_usuario_o_cliente',
            notify: ''
          }
        ],
        menuDispatcher : [
          {
            name  : 'Tickets de Contrato',
            icon  : 'style',
            notify: '',
            children: [
              {
                name  : 'Incidencias con equipo',
                path  : '/tickets/contrato/incidencia_con_equipo',
                key   : 'incidencia_con_equipo',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Solicitud de insumo',
                path  : '/tickets/contrato/solicitud_de_insumo',
                key   : 'solicitud_de_insumo',
                icon  : 'circle',
                notify: ''
              }
            ]
          },
          {
            name    : 'Tickets de Garantias',
            icon    : 'style',
            notify  : '',
            children: [
              {
                name  : 'Sin atención',
                path  : '/tickets/garantia/sin atencion',
                key   : 'garantia_sin_atencion',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Sin asignación',
                path  : '/tickets/garantia/sin asignacion',
                key   : 'garantia_sin_asignar',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Campo',
                path  : '/tickets/garantia/campo',
                key   : 'garantia_campo',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Taller',
                path  : '/tickets/garantia/taller',
                key   : 'garantia_taller',
                icon  : 'circle',
                notify: ''
              }
            ]
          },
          {
            name  : 'Programacion de citas',
            path  : '/programacion/citas',
            key   : 'citas',
            icon  : 'insert_invitation',
            notify: ''
          },
          {
            name  : 'Reportes (Analitycs)',
            path  : '/reportes',
            key   : 'citas',
            icon  : 'addchart',
            notify: ''
          },
          {
            name  : 'Cuentas de usuario',
            path  : '/manager/usuarios',
            key   : 'manager_usuarios',
            icon  : 'people',
            notify: ''
          }
        ],
        menuSupervisor : [
          {
            name  : 'Tickets de Contrato',
            icon  : 'style',
            notify: '',
            children: [
              {
                name  : 'Incidencias con equipo',
                path  : '/tickets/contrato/incidencia_con_equipo',
                key   : 'incidencia_con_equipo',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Solicitud de insumo',
                path  : '/tickets/contrato/solicitud_de_insumo',
                key   : 'solicitud_de_insumo',
                icon  : 'circle',
                notify: ''
              }
            ]
          },
          {
            name    : 'Tickets de Garantias',
            icon    : 'style',
            notify  : '',
            children: [
              {
                name  : 'Sin atención',
                path  : '/tickets/garantia/sin atencion',
                key   : 'garantia_sin_atencion',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Sin asignacion',
                path  : '/tickets/garantia/sin asignacion',
                key   : 'garantia_sin_asignar',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Campo',
                path  : '/tickets/garantia/campo',
                key   : 'garantia_campo',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Taller',
                path  : '/tickets/garantia/taller',
                key   : 'garantia_taller',
                icon  : 'circle',
                notify: ''
              }
            ]
          },
          {
            name  : 'Reportes (Analitycs)',
            path  : '/reportes',
            key   : 'citas',
            icon  : 'addchart',
            notify: ''
          }
        ],
        menuRecepcion : [
          {
            name    : 'Tickets de Garantias',
            icon    : 'style',
            notify  : '',
            children: [
              {
                name  : 'Sin atención',
                path  : '/tickets/garantia/sin atencion',
                key   : 'garantia_sin_atencion',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Sin asignación',
                path  : '/tickets/garantia/sin asignacion',
                key   : 'garantia_sin_asignar',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Campo',
                path  : '/tickets/garantia/campo',
                key   : 'garantia_campo',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Taller',
                path  : '/tickets/garantia/taller',
                key   : 'garantia_taller',
                icon  : 'circle',
                notify: ''
              }
            ]
          },
          {
            name  : 'Programacion de citas',
            path  : '/programacion/citas',
            key   : 'citas',
            icon  : 'insert_invitation',
            notify: ''
          },
          {
            name  : 'Reportes (Analitycs)',
            path  : '/reportes',
            key   : 'citas',
            icon  : 'addchart',
            notify: ''
          }
        ],
        menuTecnicoTaller : [
          {
            name    : 'Tickets de Garantias',
            icon    : 'style',
            notify  : '',
            children: [
              {
                name  : 'Sin atención',
                path  : '/tickets/garantia/sin atencion',
                key   : 'garantia_sin_atencion',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Sin asignación',
                path  : '/tickets/garantia/sin asignacion',
                key   : 'garantia_sin_asignar',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Campo',
                path  : '/tickets/garantia/campo',
                key   : 'garantia_campo',
                icon  : 'circle',
                notify: ''
              },
              {
                name  : 'Taller',
                path  : '/tickets/garantia/taller',
                key   : 'garantia_taller',
                icon  : 'circle',
                notify: ''
              }
            ]
          },
          {
            name  : 'Reportes (Analitycs)',
            path  : '/reportes',
            key   : 'citas',
            icon  : 'addchart',
            notify: ''
          }
        ],
        mini         : false,
        menu         : [],
        username     : localStorage.getItem('username'),
        perfil       : localStorage.getItem('perfil'),
        nombre       : localStorage.getItem('nombre'),
        razonSocial  : localStorage.getItem('razonSocial'),
        codigoCliente: localStorage.getItem('codigoCliente')
      }
    },
    created () {
      var vm = this
      vm.mini = !vm.isMovil
      vm.fetchCantidadTicketsAbiertos(err => {
        if (err) notify(vm, 'error', 'Error', err.message)
        else {
          if   (vm.perfil === 'dispatcher') vm.menu        = vm.menuDispatcher
          else if (vm.perfil === 'recepcion') vm.menu      = vm.menuRecepcion
          else if (vm.perfil === 'usuario-contrato') vm.menu        = vm.menuCustomer
          else if (vm.perfil === 'usuario') vm.menu        = vm.menuUsuario
          else if (vm.perfil === 'supervisor') vm.menu     = vm.menuSupervisor
          else if (vm.perfil === 'tecnico taller') vm.menu = vm.menuTecnicoTaller
          else {
            notify(vm, 'error', 'Error', 'El perfil no posee ninguna opcion para su menu')
            return
          }
        }
      })
      vm.fetchProcesos()
    },
    computed : {
      isMovil () {
        var vm = this
        return vm.$vuetify.breakpoint.smAndDown
      },
      abiertos () {
        var vm = this
        return vm.$store.state.ticket.abiertos
      }
    },
    methods : {
      generarNuevoTicket () {
        var vm = this
        vm.showNewTicketDispatcher = !vm.showNewTicketDispatcher
      },
      closeGenerarNuevoTicket () {
        var vm = this
        vm.showNewTicketDispatcher = false
      },
      goToGenerarTicket () {
        Router.push('/ticket-contrato/nuevo')
      },
      fetchProcesos () {
        var vm  = this
        var url = '/procesos/'
        var obj = {}
        apiGet(vm, url, obj, function (data) {
          if (data.lista) {
            vm.$store.dispatch('setCountAllDownloands', data.lista.length)
          }
        }, function (err) {
          notify(vm, 'error', 'Error', err.message)
        }, function () {
        })
      },
      fetchCantidadTicketsAbiertos (callback) {
        var vm = this
        var url = 'ticket/abiertos/count'
        var obj = {}
        apiGet(vm, url, obj, function (data) {
          var ticketsAbiertos = {}
          const cantidades = data.lista[0]
          if (vm.perfil === 'usuario-contrato' || vm.perfil === 'usuario') {
            ticketsAbiertos.all_usuario_o_cliente = cantidades.ticketsAbiertos
          } else {
            // const cantidades = data.lista[0]
            ticketsAbiertos.incidencia_con_equipo     = cantidades.ticketsAbiertosIncidenciaConEquipo
            ticketsAbiertos.solicitud_de_insumo       = cantidades.ticketsAbiertosSolicitudInsumo
            ticketsAbiertos.garantia_sin_asignar      = cantidades.ticketsAbiertosGaratiaSinAsignacion
            ticketsAbiertos.garantia_campo            = cantidades.ticketsAbiertosGarantiaCampo
            ticketsAbiertos.garantia_taller           = cantidades.ticketsAbiertosGarantiaTaller
            ticketsAbiertos.garantia_sin_atencion     = cantidades.ticketsAbiertosGarantiaSinAtencion
          }
          vm.$store.dispatch('setContadores', ticketsAbiertos)
          callback && callback(null)
        }, function (err) {
          callback ? callback(err) : notify(vm, 'error', 'Error', err.message)
        })
      },
      logout () {
        localStorage.clear()
        window.location.href = '/'
      }
    }
  }
  </script>
  <style lang="stylus" scoped>
  </style>



// WEBPACK FOOTER //
// View_sidebar.vue?0dea4c45